import { render, staticRenderFns } from "./TariffFeaturesCard.vue?vue&type=template&id=f76dfb90&scoped=true&"
import script from "./TariffFeaturesCard.vue?vue&type=script&lang=js&"
export * from "./TariffFeaturesCard.vue?vue&type=script&lang=js&"
import style0 from "./TariffFeaturesCard.vue?vue&type=style&index=0&id=f76dfb90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76dfb90",
  null
  
)

export default component.exports